import React, { useState } from 'react';
import { useWallet } from '../../contexts/WalletContext';
import './WalletModal.css';

/**
 * R43 : WalletModal — choisir / connecter / créer un wallet.
 * Wallets populaires détectés (Phantom, Solflare, Backpack…) + création
 * d'un wallet Elementum (secret affiché une seule fois).
 */
const WalletModal = ({ onClose }) => {
  const { wallets, connected, busy, error, mainnetBalance, orinBalance, connectProvider, createWallet, disconnect } = useWallet();
  const [created, setCreated] = useState(null); // { publicKey, secret }
  const [confirmed, setConfirmed] = useState(false);

  const handleCreate = async () => {
    const w = await createWallet();
    if (w) setCreated(w);
  };

  const downloadSecret = () => {
    const blob = new Blob([created.secret], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `elementum-wallet-${created.publicKey.slice(0, 8)}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="wm-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="wm-modal">
        <button className="wm-close" onClick={onClose} aria-label="Fermer">✕</button>

        {connected ? (
          <div className="wm-connected">
            <h3>✅ Wallet connecté</h3>
            <p className="wm-name">{connected.name}</p>
            <p className="wm-address">{connected.address}</p>
            <div className="wm-balances">
              <div className="wm-balance-row">
                <span className="wm-balance-label">◎ SOL <em>mainnet</em></span>
                <span className="wm-balance-value sol">
                  {mainnetBalance !== null && mainnetBalance !== undefined
                    ? Number(mainnetBalance).toFixed(4)
                    : '—'}
                </span>
              </div>
              <div className="wm-balance-row">
                <span className="wm-balance-label">ORIN <em>devnet</em></span>
                <span className="wm-balance-value orin">
                  {orinBalance !== null && orinBalance !== undefined
                    ? Number(orinBalance).toLocaleString('fr-FR')
                    : '—'}
                </span>
              </div>
            </div>
            <button className="wm-btn danger" onClick={() => { disconnect(); onClose(); }}>
              Déconnecter
            </button>
          </div>
        ) : created ? (
          <div className="wm-created">
            <h3>🔑 Wallet créé !</h3>
            <p className="wm-address">{created.publicKey}</p>
            <div className="wm-warning">
              ⚠️ <strong>Clé privée — sauvegardez-la maintenant.</strong><br />
              Elle ne sera <strong>jamais réaffichée</strong> et n'est stockée nulle part.
              Sans elle, le wallet et ses cartes sont perdus à jamais.
            </div>
            <button className="wm-btn" onClick={downloadSecret}>📥 Télécharger la clé (JSON)</button>
            <label className="wm-confirm">
              <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
              J'ai sauvegardé ma clé privée
            </label>
            <button className="wm-btn primary" disabled={!confirmed} onClick={onClose}>
              Terminer
            </button>
          </div>
        ) : (
          <div className="wm-choose">
            <h3>Connecter un wallet</h3>
            {wallets.length === 0 && (
              <p className="wm-hint">
                Aucun wallet détecté. Installez <a href="https://phantom.app" target="_blank" rel="noopener noreferrer">Phantom</a>,{' '}
                <a href="https://solflare.com" target="_blank" rel="noopener noreferrer">Solflare</a> ou{' '}
                <a href="https://backpack.app" target="_blank" rel="noopener noreferrer">Backpack</a> —
                ou créez un wallet directement ci-dessous.
              </p>
            )}
            {wallets.map((w) => (
              <button key={w.name} className="wm-wallet" onClick={() => connectProvider(w)} disabled={busy}>
                {w.icon ? <img src={w.icon} alt="" /> : <span className="wm-wallet-icon">👛</span>}
                {w.name}
              </button>
            ))}
            <div className="wm-sep"><span>ou</span></div>
            <button className="wm-btn primary" onClick={handleCreate} disabled={busy}>
              {busy ? '⏳ …' : '➕ Créer un wallet Elementum'}
            </button>
            <p className="wm-hint small">Wallet généré localement côté serveur, devnet uniquement. Aucune donnée personnelle.</p>
          </div>
        )}

        {error && <p className="wm-error">⚠️ {error}</p>}
      </div>
    </div>
  );
};

export default WalletModal;
